import React, {PureComponent} from 'react';
import {Container, Row, Col, Button} from 'reactstrap';
import debounce from 'debounce';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import classnames from "classnames";

//utils
import {getStoreData} from "../../utils/getStoreData";

//redux
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {fetchVisit1Data} from "../../redux/actions/visit1/visit1Action";
import {fetchPatientData} from "../../redux/actions/patients/patientsAction";

//components
import IconButton from "../_commonComponents/buttons/IconButton";
import {Visit1} from './components/Visit1';
import Loading from '../_commonComponents/Loading';

//constants
import {GET, SET, SUB_VISIT1_OBJECT} from "../../config/requestConstants";
import {INV_SUB_PATH} from "../../config/baseConstants";

const SCROLL_LIMIT = 300;

const Title = React.forwardRef((props, ref)=>{
    return (
        <section ref={ref} />
    );
});

class Visit1Form extends PureComponent {
    static _onChange(callback) {
        callback();
    }

    static _onCheckboxChange = (callback) => {
        callback();
    };

    constructor(prosp) {
        super(prosp);

        this.state = {
            formId: null,
            formData: {},
            windowTopPosition: 0,
            isLoading: false
        };

        this.scrollRef = React.createRef();

        Visit1Form._onChange = debounce(Visit1Form._onChange, 600);
        Visit1Form._onCheckboxChange = debounce(Visit1Form._onCheckboxChange, 50);
    }

    componentDidMount() {
       this.getInitialData();
       this.getWindowTopPosition();
       window.addEventListener('scroll', this.getWindowTopPosition);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.getWindowTopPosition);
    }

    getWindowTopPosition = () => {
        const windowTopPosition = window.pageYOffset;

        this.setState({
            windowTopPosition
        });
    };

    getInitialData = async() => {
        const {
            fetchVisit1Data
        } = this.props;

        const id = getStoreData(() => this.props.match.params.id);
        const filter =  [{name: "sub", value: id}];

        this.setState({
            isLoading: true
        });

        await fetchVisit1Data(null, filter, {}, true);
        this.setState({
            formId: getStoreData(() => this.props.formData.id),
            formData: this.props.formData,
            isLoading: false
        }, () => {
            this.getPatientData();
        })
    };

    getPatientData = () => {
        const {
            fetchPatientData
        } =this.props;

        const id = getStoreData(() => this.props.match.params.id);
        const filter = [{name: "id", value: id}];

        fetchPatientData(GET, filter, null, null, null, {}, false)
    };

    onSubmit = async (values) => {
        const {
            fetchVisit1Data,
        } =this.props;

        const {
            formId
        } = this.state;

        const data={...values, ...{id: formId}};
        await fetchVisit1Data(SET, [], data, false, SUB_VISIT1_OBJECT);
        this.setState({
            formData: this.props.formData
        })
    };

    goToPrevPage = () => this.props.history.push({pathname: INV_SUB_PATH, state: {row: this.props.rowData}});

    onChange = () => Visit1Form._onChange(this.props.handleSubmit(this.onSubmit));

    scrollToContent = () => {
        this.scrollRef.current.scrollIntoView({behavior: 'smooth'});
    };

    render() {
        const {
            name,
            status
        } = this.props;

        const {
            formData,
            windowTopPosition,
            isLoading
        } = this.state;

        return (
            <Row className={"patients"}>
                {isLoading && <Loading className="position-absolute"/>}
                <Title ref={this.scrollRef}/>
                <Col xs={12} >
                    <div className="tableHeader d-flex justify-content-between">
                        <div className="d-flex justify-content-start align-items-center">
                            <div className={"tableHeader__icon"}>
                                <FontAwesomeIcon icon={"clipboard-list"}/>
                            </div>
                            <h3 className="tableHeader__title mb-0 ml-2">Визит 1</h3>
                        </div>
                        <div>
                            <IconButton
                                icon={"users"}
                                className={"tableHeader__button"}
                                color={'secondary'}
                                onClick={this.goToPrevPage}
                                outline
                            />
                        </div>
                    </div>
                </Col>
                <Col xs={12}>
                    <Container className="visitContainer my-4">
                        <Visit1
                            id={getStoreData(() => this.props.match.params.id)}
                            name={name}
                            onChange={Visit1Form._onChange}
                            onCheckboxChange={Visit1Form._onCheckboxChange}
                            onSubmit={this.onSubmit}
                            data={formData}
                            readOnly={!status || status === 4}
                        />
                </Container>
                </Col>
                <div className="d-block d-xl-none">
                    <Button
                        color="primary"
                        className={classnames('btn-scroll p-3', windowTopPosition > SCROLL_LIMIT ? 'btn-scroll_show' : '')}
                        onClick={this.scrollToContent}
                    >
                        <FontAwesomeIcon color="white" icon="chevron-up"/>
                    </Button>
                </div>
            </Row>
        )
    }
}

const mapStateToProps = (store) => ({
    status: getStoreData(() => store.patients.formData[0].status_visit_1),
    name: getStoreData(() => store.patients.formData[0].name),
    rowData: getStoreData(() => store.patients.formData[0]),
    formData: getStoreData(() => store.visit1.formData) ? store.visit1.formData : {},
});

 const mapDispatchToProps = (dispatch) => bindActionCreators({
     fetchVisit1Data,
     fetchPatientData
 }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Visit1Form);
